var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-circle",domProps:{"innerHTML":_vm._s(_vm.favoriteListId.length)}})
}
var staticRenderFns = []

export { render, staticRenderFns }